import React from "react";
import styled from "styled-components";
import logo from "../img/logo.png";
import { useChatNavigation } from "./ChatNavigationProvider.jsx";

const Logo = () => {
  const { requestNewSituation } = useChatNavigation();

  return (
    <ImgWrapper
      type="button"
      onClick={requestNewSituation}
      aria-label="로우로우 메인으로 이동"
      title="로우로우 메인으로 이동"
    >
      <LogoImg src={logo} alt="logo" />
    </ImgWrapper>
  );
};

const ImgWrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    outline: 2px solid #00e879;
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

const LogoImg = styled.img`
  height: auto;
  width: 153px;

  @media (max-width: 744px) {
    width: 114px;
  }
`;

export default Logo;
